import React from 'react';
import { DocumentEditorContainerComponent } from '@syncfusion/ej2-react-documenteditor'

import './App.css';

function App() {
  return (
    <div className="App">
      <DocumentEditorContainerComponent height='900px'></DocumentEditorContainerComponent>
    </div>
  );
}

export default App;
